// VP-206: galeria wyników pokazuje sekcje per zadanie generowania.
// Grupowanie po jobId (kolejność wg pierwszego wystąpienia grafiki joba);
// grafiki bez przypisania (starsze wyniki, warianty regen bez źródła) lądują
// w jednej wspólnej grupie z jobId=null, renderowanej bez nagłówka zadania.
export const UNGROUPED_GRAPHICS_KEY = "__ungrouped__";

export type GraphicsJobGroup<T> = { key: string; jobId: string | null; items: T[] };

export function groupGraphicsByJob<T extends { id: string }>(
  graphics: T[],
  jobIdByGraphicId: Record<string, string>
): GraphicsJobGroup<T>[] {
  const groups: GraphicsJobGroup<T>[] = [];
  const indexByKey = new Map<string, number>();
  for (const graphic of graphics) {
    const jobId = jobIdByGraphicId[graphic.id] ?? null;
    const key = jobId ?? UNGROUPED_GRAPHICS_KEY;
    let index = indexByKey.get(key);
    if (index === undefined) {
      index = groups.length;
      indexByKey.set(key, index);
      groups.push({ key, jobId, items: [] });
    }
    groups[index].items.push(graphic);
  }
  return groups;
}
